import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { ValidationTypeDropdownComponent }         from '../../components/DomainData/ValidationTypeDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { ValidationTypeEnum } from '../../enums/index';

@Component({
  selector: 'my-contactvalidation-edit',
  templateUrl: './ContactValidationEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => ContactValidationEditComponent)}]
})
export class ContactValidationEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(ValidationTypeDropdownComponent) public validationTypeDropdownComponent: ValidationTypeDropdownComponent;    

    @Input() public record: ent.ContactValidation;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
            'validationType' : '',
            'value': '',
            'inactive': ''
        };
        
        this.form = fb.group(group);
    }


    ngOnInit(): void {
        
    }

    validationTypeChange(event: any){
        this.record.ValidationTypeID = event;
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    showPhone(): boolean {
        return this.record.ValidationTypeID == ValidationTypeEnum.PhoneNumber;
    }
    
}